var render = function render(){var _vm=this,_c=_vm._self._c;return _c('settings-layout',{attrs:{"items":_vm.items,"windowRouteName":"adminWindow","headerTitle":_vm.$t('adminTitle')}},[_c('admin-window')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }